import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {
    IConnectorsEdges,
    IFullGraphData,
    IGraphAction,
    IGraphData,
    Node,
    TGraphType,
    IAdComponentData,
    IAttachmentsData
} from './models/graph-kn.model-interfaces';
import {GraphKnDataService} from '../graph-konva/services/graph-kn.data.service';
import {combineLatest, Subscription, take} from 'rxjs';
import {GraphKnTransformService} from '../graph-konva/services/graph-kn.trasform.service';
import {GraphKnTSubscriptionService} from '../graph-konva/services/graph-kn.subscription.service';
import {GraphKnLayerSettingService} from '../graph-konva/services/graph-kn.layers-setting.service';
import {GraphKnEdgeService} from '../graph-konva/services/graph-kn.edge.service';
import {
    BUSINESS_PROCESS_LAYER_ID,
    CONTRACT_LAYER_ID,
    DagreNodesOnlySettings,
    IKnUIOptions,
    INodeChangeEvent,
    IStageSettings,
    TLayerIDs
} from './models/graph-kn.cm-api-models';
import {GraphKnRestrictionsService} from './services/graph-kn.restrictions.service';
import {COLOR_CONTRACT_LAYER, COLOR_STAGE} from './models/graph-kn.cm.layers-model-const';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppGraphSettingsFormComponent } from './components/graph-settings/graph-settings-form.component';
import { IconBaseService } from '../../services/icon-base.service';
import { GraphKnStageService } from './services/graph-kn.stage.service';

@Component({
    selector: 'app-graph-konva',
    templateUrl: 'app-graph-konva.component.html',
    styleUrl: './app-graph-konva.component.scss',
})
export class GraphKonvaComponent {
    public navPanelData:IAdComponentData = {top:100, left:100,visibility:'hidden'}
    public userListData:IAdComponentData = {top:300, left:100,visibility:'hidden'}
    public attachmentsData:IAttachmentsData = {top:300, left:100,visibility:'hidden'}
    @Input() contractGuid: string = '';
    @Input() graphType!: TGraphType;
    @Input() stageSettings!: IStageSettings;
    @Input() layoutDagreSettings!: Map<TLayerIDs, DagreNodesOnlySettings>
    @Input() contractGD!: IFullGraphData;
    @Input() contractStatus!: string;
    @Input() bpGD!: IGraphData;
    @Input() graphUISetting!: Map<TLayerIDs, IKnUIOptions>
    @Output() contextAction: EventEmitter<IGraphAction> = new EventEmitter<IGraphAction>
    @Output() selectedBP_Step: EventEmitter<Node | undefined> = new EventEmitter<Node | undefined>
    @Output() emitEdgeEvent: EventEmitter<IConnectorsEdges> = new EventEmitter<IConnectorsEdges>
    @Output() emitNodeEvent: EventEmitter<INodeChangeEvent> = new EventEmitter<INodeChangeEvent>
    public stageColor = COLOR_STAGE
    public graphIsLoading: Boolean = false
    private subscriptions = new Subscription
    private graphSettingsDialogRef!:MatDialogRef<AppGraphSettingsFormComponent>
    constructor(
        private knStageService: GraphKnStageService,
        private knDataService: GraphKnDataService,
        private knEdgeervice: GraphKnEdgeService,
        private knLayerSettingService: GraphKnLayerSettingService,
        private knTransformService: GraphKnTransformService,
        private knTSubscriptionService: GraphKnTSubscriptionService,
        private knRestrictionsService: GraphKnRestrictionsService,
        private iconBaseService:IconBaseService,
        private dialog:MatDialog,
        private cds:ChangeDetectorRef
    ) {
        this.emitEdgeEvent = this.knEdgeervice.emitEdgeEvent
        this.emitNodeEvent = this.knDataService.emitNodeEvent
    }

    ngOnDestroy(): void {
      this.knDataService.resetValues();
      this.subscriptions.unsubscribe();
    }

    ngOnInit(): void {
        this.contractGD?.projects ? this.knRestrictionsService.prepareRestrictions(structuredClone(this.contractGD)) : null;
        this.prepareData();
        this.prepareGraph();
        this.setSubscriptions();
    }

    setSubscriptions() {
        this.subscriptions.add(this.knDataService.subGraphIsLoading.asObservable().subscribe(isLoading=>{
            this.graphIsLoading = isLoading
            this.cds.detectChanges()
        }))
        this.subscriptions.add(this.knDataService.subToolBarOpen.asObservable().subscribe(data=>{
            this.navPanelData = data;
            this.cds.detectChanges()
        }))
        this.subscriptions.add(this.knDataService.subUserListOpen.asObservable().subscribe(data=>{
            this.userListData = data;
            this.cds.detectChanges()
        }))
        this.subscriptions.add(this.knDataService.subAttachementsListOpen.asObservable().subscribe(data=>{
            this.attachmentsData = data;
            this.cds.detectChanges()
        }))
        this.subscriptions.add(this.knTSubscriptionService.subReceivedSubContractData())
        this.subscriptions.add(this.knTSubscriptionService.subTaskData())
        this.subscriptions.add(this.knTSubscriptionService.subContractNameRefresh())
        this.subscriptions.add(this.knTSubscriptionService.subNewStepsAdded())
        this.subscriptions.add(this.knTSubscriptionService.subContractSettingsChanged())
        this.subscriptions.add(this.knTSubscriptionService.subGraphSettingsChanged())
        this.graphType === 'contractLayer' ? null : this.subscriptions.add(this.knTSubscriptionService.subReceivedBPData())
    }

    prepareData() {
      this.knDataService.graphUISetting = this.graphUISetting
      this.knDataService.nodeWidth = 0;
      this.knDataService.nodeHeight = 0;
      this.knDataService.graphType = this.graphType;
      this.knDataService.stageSettings = this.stageSettings;
      this.knDataService.layoutDagreSettings = this.layoutDagreSettings;
      this.knDataService.layoutDagre.settings = this.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID) || this.knDataService.defaultDagreSetting;
      this.knDataService.contractGD.set(CONTRACT_LAYER_ID, structuredClone(this.contractGD));

    }
    prepareDataAfterPrivilieges() {
      this.knDataService.contractStatus = this.contractStatus
      let contractGD = this.knDataService.contractGD.get(CONTRACT_LAYER_ID)
      contractGD?.nodes?.length ? this.knTransformService.transformIncomingContract(contractGD,this.contractGuid) : null;
      this.knDataService.lastContractStepId = contractGD?.nodes[contractGD?.nodes?.length - 1]?.id.replace(/image|number/g, '') || '';
      this.bpGD?.nodes?.length ? this.knDataService.generateGraphDataBP$.next(this.bpGD) : null;
    }

    prepareGraph() {
			this.knStageService.setStage(this.knDataService.stageSettings);
			this.subscriptions.add(
				combineLatest([
					this.knTSubscriptionService.subUserPrivilegesSet(),
					this.knDataService.updateSettings()
				])
				.pipe(take(1))
				.subscribe(() => {
					this.prepareDataAfterPrivilieges()
					this.contractGD ? this.knLayerSettingService.setContractLayer(CONTRACT_LAYER_ID, true, COLOR_CONTRACT_LAYER) : null
				}));
    }
    openGraphSettings(){
      this.graphSettingsDialogRef = this.dialog.open(AppGraphSettingsFormComponent,{minWidth:'700px'})
    }
}